import {EMPTY, MonoTypeOperatorFunction, timer} from 'rxjs';
import {debounce} from 'rxjs/operators';

/** Only debounces if we pass the predicate. Otherwise, emits immediately. */
export function debounceIf<T>(
  predicate: (value: T) => boolean,
  duration: number,
): MonoTypeOperatorFunction<T> {
  return (source$) => source$.pipe(debounce((value) => (predicate(value) ? timer(duration) : EMPTY)));
}
